import { Modal } from "components";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { useTarget } from "hooks/data/use-targets";
import TargetView from "components/cards/target-view";

export default function ViewTargetContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { loading, targetBadge } = useTarget({
    targetId: searchParams?.id || "",
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="View Target Details"
      description="Details of Target are shown below"
    >
      <TargetView target={targetBadge} />
    </Modal>
  );
}
